export default "__VITE_ASSET__2h1yf45F__"